// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const TOAST_ERRORS_IN_FORM = "Formul\u00e1\u0159 se nepoda\u0159ilo odeslat. N\u011bkde v n\u011bm m\u00e1\u0161 chybu.";
